// hero slider
gsap.from(".template-index .hero-silder-wrapper .content-box",{
  y:200,
  opacity:0,
  delay:1,
  scrollTrigger:".template-index .hero-silder-wrapper"
});

// usp section

gsap.from(".usp-block", {
  duration:1.5,
  y: 200,
  scrollTrigger:".usp-block",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

// banner box
gsap.from(".banner__box", {
  duration:1.5,
  x: 200,
  scrollTrigger:".banner__box",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

// banner box
gsap.from(".banner__content", {
  duration:1.5,
  x: 200,
  scrollTrigger:".banner__content",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

// collection list

gsap.from(".collection-list", {
  duration:1.5,
  y: 200,
  scrollTrigger:".collection-list",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});


// image with text

gsap.from(".image-with-text__content", {
  duration:1.5,
  x: -200,
  scrollTrigger:".image-with-text__content",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

gsap.from(".image-with-text__media-item", {
  duration:1.5,
  x: 200,
  scrollTrigger:".image-with-text__media-item",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

// faq sections

gsap.from(".grid__item", {
  duration:1.5,
  y: 200,
  scrollTrigger:".grid__item",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

// blog sections

gsap.from(".animate-blog", {
  duration:1.5,
  y: 200,
  scrollTrigger:".animate-blog",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});


//Animation on Headings
gsap.from(".animate-coll .collection-list-title", {
  y: 150,
  opacity: 0,
  duration: 0.3,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".animate-coll .collection-list-title",
    start: "top 700px", // Start animation when top of the element hits 300px from the top of the viewport
    end: "top 100px", // End animation when top of the element hits 100px from the top of the viewport
  }
});

// Two columns

gsap.from(".multicolumn-list", {
  duration:1.5,
  y: -300,
  scrollTrigger:".collection-list",
  stagger:0.3,
  opacity: 0,
  ease: "power1.inOut",
  smooth: 1
});

